export const SERVER_LINK = "https://vidyalayaapi.appnestit.com"